(function(){
    'use strict'
    angular.module("Directives").directive("bbaMapJobRouteAndLocation", bbaMapJobRouteAndLocation);
    bbaMapJobRouteAndLocation.$inject = ['$timeout'];

    function bbaMapJobRouteAndLocation($timeout){
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/components/job-details/bbaMapJobRouteAndLocation.html',
            scope: {
                job: '='
            },
            link: bbaMapJobRouteAndLocationLink
        }

        function bbaMapJobRouteAndLocationLink(scope, element, attrs){
            let googleMapInstance;

            scope.initialize = initialize;            
            function initialize(){
                $timeout(() => {
                    initMap();
                    initMarkers();
                }, 100);
            }

            function initMap(){
                googleMapInstance = new google.maps.Map(document.getElementById('job-route-and-location-map'), {
                    disableDefaultUI: true
                });
            }

            function initMarkers(){
                const bounds = new google.maps.LatLngBounds();
                const dst = new google.maps.Marker({
                    position: new google.maps.LatLng(scope.job.destinationAddress.latitude, scope.job.destinationAddress.longitude),
                    map: googleMapInstance
                });

                const src = new google.maps.Marker({
                    position: new google.maps.LatLng(scope.job.sourceAddress.latitude, scope.job.sourceAddress.longitude),
                    map: googleMapInstance
                });

                bounds.extend(dst.position);
                bounds.extend(src.position);
                googleMapInstance.fitBounds(bounds);
            }
        }
    }
})()


// WEBPACK FOOTER //
// ./js/directives/component/job-details/bbaMapJobRouteAndLocation.js